import React from "react";
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { CeleryTask } from "../../../api/celery";
import { ColorsEnum } from "../../../common/theme/colors";
import * as S from "../style";

interface TasksTableProps {
  tasks: CeleryTask[];
  stateColours: Record<string, string>;
  onTaskClick: (task: CeleryTask) => void;
}

const fmtTs = (ts?: number): string => {
  if (!ts) return "—";
  return new Date(ts * 1000).toLocaleString();
};

const TasksTable: React.FC<TasksTableProps> = ({
  tasks,
  stateColours,
  onTaskClick,
}) => (
  <TableContainer component={S.StyledTableContainer}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell width="20%">Task Name</TableCell>
          <TableCell width="10%">State</TableCell>
          <TableCell width="15%">Worker</TableCell>
          <TableCell width="20%">Received</TableCell>
          <TableCell width="15%">Runtime</TableCell>
          <TableCell width="20%">ID</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {tasks.map((t) => (
          <TableRow
            key={t.id}
            hover
            onClick={() => onTaskClick(t)}
            sx={{
              cursor: "pointer",
              transition: "background-color 0.15s ease",
            }}
          >
            <TableCell
              sx={{
                maxWidth: 280,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                {t.name || "(unnamed)"}
              </Typography>
            </TableCell>
            <TableCell>
              <Chip
                label={t.state || "UNKNOWN"}
                size="small"
                sx={{
                  bgcolor: stateColours[t.state?.toUpperCase() || ""] || ColorsEnum.grey,
                  color: ColorsEnum.white,
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  borderRadius: "12px",
                }}
              />
            </TableCell>
            <TableCell>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: "0.8rem" }}
              >
                {t.worker || "—"}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                {fmtTs(t.received)}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                {t.runtime != null ? `${t.runtime.toFixed(2)}s` : "—"}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                fontSize: "0.7rem",
                color: "text.secondary",
                maxWidth: 80,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={t.id}
            >
              <Typography variant="body2" noWrap>{t.id}</Typography>
            </TableCell>
          </TableRow>
        ))}
        {tasks.length === 0 && (
          <TableRow>
            <TableCell colSpan={6} align="center" sx={{ py: 4, color: "text.secondary" }}>
              No tasks found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TasksTable;
